import React, { useRef, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Mensaje } from "../../components/mensajes";

import useTable from "../../components/useTable";
import Controls from "../../components/controls/Controls";
import { Dimmer } from "../../components/spinner";

import { TableBody, TableRow, TableCell, InputAdornment } from "@mui/material";

import axios from "axios";

const TablaPuc = (props) => {
  /*  variables de estados */

  let op = require("../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");

  const btnCancela = useRef();
  const [mostrar, setMostrar] = useState(false);
  const [titulo, setTitulo] = useState();
  const [msg, setMsg] = useState();
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const [itemSelect, setItemSelect] = useState(-1);
  const [activo, setActivo] = useState(true);
  const [values, setValues] = useState({});

  const headCells = [
    {
      id: "idpuc",
      label: "ID",
      width: "80px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "descripcion",
      label: "DESCRIPCIÓN",
      width: "600px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    {
      id: "puc",
      label: "CODIGO",
      width: "80px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
    },
    /*        { id: 'accion', label: 'OPCIONES', width: '120px', textAlign: "center", background: "rgba(5, 81, 130, 1)", fontSize: "10px", color: "white" },
     */
  ];

  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTable(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;

    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              x.idpuc.toLowerCase().includes(target.value.toLowerCase()) ||
              x.descripcion
                .toLowerCase()
                .includes(target.value.toLowerCase()) ||
              x.puc.toLowerCase().includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
        }
      },
    });
  };

  const seleccionarPuc = (idpuc) => {
    let endpoint = `${op.conexion}/api/catalogo/puc?idpuc=${idpuc}`;

    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          var acti = [];
          for (let i = 0; i < response.data.length; i++) {
            acti.push({
              idpuc: response.data[i].idpuc,
              descripcion: response.data[i].descripcion,
              puc: response.data[i].puc,
            });
          }
          setRecords(acti);
        }

        setActivate(false);
      })
      .catch(function (error) {
        setTitulo("ERROR");
        setMsg(error.response.data.message);
        setMostrar(true);
        setActivate(false);
      });
  };

  const blanquear = () => {
    setMostrar(false);
    setTitulo("");
    setMsg("");
    setActivate(false);
    setRecords([]);
    setFilterFn({
      fn: (items) => {
        return items;
      },
    });
  };

  const seleccionarLista = (index) => (event) => {
    var valor = {
      idpuc: values.idpuc,
      descripcion: values.descripcion,
      puc: values.puc,
    };

    console.log(valor);
    blanquear();
    props.onHideAceptaCatPuc(valor);
  };

  const handleCloseMensa = () => {
    setMostrar(false);
  };

  const cancelar = () => {
    blanquear();
    props.onHideCloseCatag();
  };

  const seleccionarFila = (index) => (event) => {
    setItemSelect(index);
    setActivo(false);

    setValues(recordsAfterPagingAndSorting()[index]);
  };

  return (
    <Modal
      {...props}
      size="lg"
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      backdrop="static"
      keyboard={false}
      onShow={() => {
        seleccionarPuc();
      }}
    >
      <Modal.Header className="azulGradiant modal-header">
        <Modal.Title>Seleccionar Clasificador Presupuestario.</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Mensaje
          titulo={titulo}
          mensaje={msg}
          show={mostrar}
          onHide={handleCloseMensa}
        />
        <Dimmer active={activate} inverted></Dimmer>
        <div className="col-md-12" style={{ marginBottom: "10px" }}>
          <div className="col-md-12 m-0">
            <div className="input-group input-group-sm mb-3 m-0 col-md-5">
              <input
                type="text"
                onChange={handleSearch}
                className="form-control search-input rounded-pill"
              />
            </div>
          </div>
        </div>
        <div className="col-md-12" style={{ margin: "auto" }}>
          <TblContainer>
            <TblHead />

            <tbody>
              {records &&
                recordsAfterPagingAndSorting().map((item, index) => (
                  <tr
                    key={item.idpuc}
                    style={{
                      padding: "0",
                      cursor: "pointer",
                      background:
                        itemSelect === index ? "lightskyblue" : "white",
                    }}
                    onClick={seleccionarFila(index)}
                  >
                    <td
                      style={{
                        fontSize: "10px",
                        textAlign: "center",
                        width: "10px",
                        verticalAlign: "middle",
                      }}
                    >
                      {item.idpuc}
                    </td>
                    <td
                      style={{
                        fontSize: "10px",
                        textAlign: "left",
                        width: "auto",
                        verticalAlign: "middle",
                      }}
                    >
                      {item.descripcion}
                    </td>
                    <td
                      style={{
                        fontSize: "10px",
                        textAlign: "left",
                        width: "20px",
                        verticalAlign: "middle",
                      }}
                    >
                      {item.puc}
                    </td>
                    {/*  <td align="center" style={{ fontSize: "10px", textAlign: "center", width: "120px", padding: 0, verticalAlign: "middle" }}>
                                            <button style={{ width: "120px" }} onClick={seleccionarPus(index)} className="btn btn-outline-info"><i className="fas fa-edit"> Seleccionar </i> </button>
                                        </td> */}
                  </tr>
                ))}
            </tbody>
          </TblContainer>
          <TblPagination />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn btn-sm btn-success rounded-pill"
          disabled={activo}
          onClick={seleccionarLista()}
        >
          <i className="fas fa-check-circle"> Aceptar</i>{" "}
        </button>

        <button
          ref={btnCancela}
          onClick={cancelar}
          className="btn btn-danger btn-sm rounded-pill col-md-2"
        >
          <i className="fa"> Cancelar</i>
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default TablaPuc;
